
import React      from 'react';
import Modal      from 'react-modal';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class Overlay extends React.Component {

    _getOverlayStyle(size) {

        var overlayStyle = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, .5)',
                overflowY: 'auto',
                top: '75px',
            },
            content: {
                maxWidth                   : 'none',
                margin                     : '0 auto 20px auto',
                position                   : 'absolute',
                top                        : '50px',
                bottom                     : 'auto',
                border                     : '1px solid #a5a5a5',
                overflow                   : 'visible',
                WebkitOverflowScrolling    : 'touch',
                borderRadius               : 0,
                padding                    : '25px'
            }
        };

        switch (size) {

            case 'small':
                overlayStyle.content.maxWidth = '400px';
                break;

            case 'medium':
                overlayStyle.content.maxWidth = '700px';
                break;
        }

        return overlayStyle;
    }

    _afterOpenModal() {

        document.body.classList.add('ReactModal__Body--open')
    }

    render() {

        return (
            <Modal isOpen={ this.props.isOpen }
                   onAfterOpen={ this._afterOpenModal }
                   style={ this._getOverlayStyle(this.props.size) }>

                <header styleName="header">

                    <h2 styleName="title">
                        { this.props.title }
                    </h2>

                    <div onClick={ this.props.closeOverlay }
                         styleName="close-button">

                        <span styleName="close-icon">&times;</span>

                    </div>

                </header>

                { this.props.children }

            </Modal>
        );
    }
}

export default CSSModules(Overlay, style);


// WEBPACK FOOTER //
// ./components/Overlay/index.js